var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"response btn btn-default border whitespace-no-wrap",class:{ selected: _vm.selected , ellipsis : _vm.hasLongOption},style:({
      color: _setup.color,
      'background-color': _setup.bgColor,
      'border-color': _vm.response.color
  }),attrs:{"value":_vm.response.uuid},on:{"click":_setup.handleClick}},[_vm._v(" "+_vm._s(_setup.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }